import { useQuery } from "@tanstack/react-query";
import { getApplicantDetails, getApplicantImage } from "../../api/application";

/**
 * Hook that handles the applicant details api calls, uses react-query
 * @returns The details of the applicant and the image
 */
const useApplicantDetails = (applicantID: number) => {
  // ############
  // GET QUERIES
  // ############

  // applicantDetails query
  const { data: applicantDetailsData } = useQuery({
    queryKey: ["applicantDetails", applicantID],
    queryFn: () => getApplicantDetails(applicantID),
  });

  const applicantDetails = applicantDetailsData ? applicantDetailsData.data : null;

  // ----------------------------------------------------------------------------------
  // getApplicantImage query
  const { data: applicantImageData } = useQuery({
    queryKey: ["applicantImage", applicantID],
    queryFn: () => getApplicantImage(applicantID),
  });

  const applicantImage = applicantImageData ? applicantImageData.data : null;

  // ----------------------------------------------------------------------------------
  return {
    applicantDetails,
    applicantImage,
  };
};

export default useApplicantDetails;
